module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 童星库")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_list_item"
  }, [_c('div', {
    staticClass: "item_title"
  }, [_vm._v("童星库")]), _vm._v(" "), _c('div', {
    staticClass: "item_but_up"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.goApply(1)
      }
    }
  }, [_vm._v("开始申报")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_but_down"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.type = '1'
      }
    }
  }, [_vm._v("申报须知")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "申报须知",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n                申报须知内容。。。。\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goApply()
      }
    }
  }, [_vm._v("立即报名")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fd2563b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/tongyan/TongyanApplyIndex.vue
// module id = 1294
// module chunks = 0